module.exports = __webpack_public_path__ + "static/media/down-red.6a765633.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/down-red.svg
// module id = ./src/assets/icons/down-red.svg
// module chunks = 0